<script>
    // Stores 
    import { textSite, mailCondominios } from '../store.js';    

    // Componentes
    import { Router, Link, link , Route } from "svelte-routing";
    import PageHeader from "../components/PageHeader.svelte";
    import Forms from "../components/Forms.svelte";

    // Code
    let titlePage = 'Proposta de Administração de Condomínio';

    let fields = [
        {
            title:      'Seu nome *',
            name:       'nome',
            required:   'required',
        },
        {
            title:      'Telefone *',
            name:       'telefone',
            required:   'required',
            classe:     'mask-telefone',
        },
        {
            title:      'Email *',
            name:       'email',
            type:       'email',
            required:   'required',
        },   
        {
            title:      'Nome do condomínio *',
            name:       'condominio-nome',
            required:   'required'
        },
        {
            title:      'Endereço *',
            name:       'condominio-endereco',
            required:   'required'
        },
        {
            title:      'Quantidade de unidades *',
            name:       'condominio-unidades',
            required:   'required',
        },
        {
            title:      'Tipo de Condomínio *',
            name:       'condominio-tipo',
            required:   'required',
            type:       'select',
            selectValues: [
                {
                    title: 'Selecione',
                    value: ''
                },                
                {
                    title: 'Residencial',
                    value: 'Residencial'
                },
                {
                    title: 'Comercial',
                    value: 'Comercial'
                },
                {
                    title: 'Misto',
                    value: 'Misto'
                },
            ]            
        },
        {
            title:      'Possui administradora',
            name:       'condominio-possui-administradora',
            type:       'select',
            selectValues: [
                {
                    title: 'Selecione',
                    value: ''
                },                
                {
                    title: 'Sim',
                    value: 'Sim'
                },
                {
                    title: 'Não',
                    value: 'Não'
                }
            ]            
        },
        {
            title:      'Administradora Atual',
            name:       'condominio-administradora',
        },
        {
            title:      'Taxa de Administração',
            name:       'condominio-taxa',
        },
        {
            title:      'Possui síndico?',
            name:       'condominio-possui-sindico',
            type:       'select',
            selectValues: [
                {
                    title: 'Selecione',
                    value: ''
                },
                {
                    title: 'Sim',
                    value: 'Sim'
                },
                {
                    title: 'Não',
                    value: 'Não'
                }
            ]
        },     
        {
            title:      'Nome do síndico',
            name:       'sindico-nome',
        },                   
        {
            title:      'Apartamento do síndico',
            name:       'sindico-apartamento',
        },           
        {
            title:      'Outras informações',
            name:       'outras-informacoes',
            type:       'textarea'
        },           
    ];      
    
    const message = `
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
Nome do condomínio: {condominio-nome}
Endereço: {condominio-endereco}
Quantidade de unidades: {condominio-unidades}    
Tipo de Condomínio: {condominio-tipo}
Possui administradora: {condominio-possui-administradora}
Administradora Atual: {condominio-administradora}
Taxa de Administração: {condominio-taxa}
Possui síndico? {condominio-possui-sindico}
Nome do síndico: {sindico-nome}
Apartamento do síndico: {sindico-apartamento}
Outras informações: {outras-informacoes}

{info}
    `;

    let loading = false;
    function send() {
        loading = true;
    }    

</script>

<section class="internas">
    <PageHeader title={titlePage} buttons=""></PageHeader>
    <div class="container">
        <p class="text-center">
            Estamos prontos para assessorá-lo a encontrar as melhores soluções para o seu condomínio.
        </p>
        <p class="text-center">
            Venha conhecer nossa empresa ou solicite-nos uma proposta, que brevemente entraremos em contato com você.
        </p>
        <div class="offset-md-3 col-md-6 pl-0 pr-0">
            <hr class="line-separator">
            <Forms fields={fields} destiny={$mailCondominios} subjectTitle="Proposta de administração de condomínio | {$textSite}" {message} htmlbody={false} />
        </div>
    </div>
</section>